import React from 'react';
import withRouter from 'src/config/withRouter';
import { withTranslation } from 'react-i18next';
// material ui
import IconButton from '@mui/material/IconButton';
import { Close, LocationOnOutlined} from '@mui/icons-material';
import withStyles from '@mui/styles/withStyles';
// components
import Bar from '../Bar';
import logoImg from '../../assets/images/logo.png';
import '../../assets/stylesheet/editactivity.css';

const styles = theme => ({
    cont:{
        [theme.breakpoints.between('xs','md')]:{
            marginLeft:'0px !important',
            marginRight:'0px !important',
            paddingTop:'0px',
        },
    },

    imgDiv:{
        alignSelf: 'center',
        position: 'relative',
        margin: '0px 0px',
        maxHeight: '250px',
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'column',
        width:'500px',
        objectFit:'fill',
        backgroundColor: '#F7F7F7',
        borderRadius: '8px',
        [theme.breakpoints.down('md')]:{
            width:'90%'
		}
    },

    coverImg:{
        width: '100%',
        maxHeight:'250px',
        borderRadius:'8px',
        objectFit:'contain',
        [theme.breakpoints.up('sm')]:{
            height:'250px',
		}
    },

    descDiv:{
        alignSelf: 'center',
        outline: 'none',
        border: 'none',
        backgroundColor: '#F7F7F7',
        width: '100%',
        margin: '10px 0px',
        paddingLeft: '10px',
        fontSize: '16px',
        color:'#000',
        fontFamily: "'Poppins', sans-serif",
        borderRadius: '8px',
        boxSizing:"border-box"
    },

    textSpan:{
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        fontFamily:"'Cairo', sans-serif"
    },

    companyName:{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width:'300px',
        fontFamily:"'Cairo', sans-serif",
        textTransform:'capitalize',
        [theme.breakpoints.down('md')]:{
            width: '210px',
		}
    },

    showBtn:{
        color: '#B329CD',
        fontSize: '13px',
        marginLeft: '8px',
        cursor:'pointer',
        fontFamily:"'Cairo', sans-serif"
    },

    bookBtn:{
        textDecoration: 'none',
        alignSelf: 'center',
        border: 'none',
        outline: 'none',
        borderRadius: '50px',
        backgroundColor: '#0F467A',
        color: '#fff',
        padding: '12px 20px',
        cursor: 'pointer',
        textAlign: 'center',
        '-webkit-box-shadow': '0 10px 6px -6px #bdc3c7',
        '-moz-box-shadow': '0 10px 6px -6px #bdc3c7',
        boxShadow: '0 10px 6px -6px #bdc3c7',
        fontSize:'16px',
        [theme.breakpoints.down('md')]:{
            fontSize:'9px'
        }
    }
})

class CompanyDetail extends React.Component {
    _isMounted = false;
    constructor() {
        super();
        this.state = {
            showLess: true,
            textLength: 300,
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setShowBtn = val => (this.setState({showLess:val}));

    redirect = () => {
        let { id } = this.props.companyDetail;
        if(id) this.props.history.push(`/booking/${id}`);
    }

    render() {
        const { showLess,textLength } = this.state;
        const { companyDetail, i18n, classes, close } = this.props;
        let {name,image,countryCode,city,description} = companyDetail;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;

        return (
            (<div dir={isRTL === 'ar' ? 'rtl' :'ltr'} style={{fontFamily}} className={classes.cont}>
                <Bar>
                    <div className='addActBar'>
                        <div className='addActLeftSide'>
                            <IconButton onClick={close} size="large">
                                <Close className='leftArrowIcon'/>
                            </IconButton>
                            <span className={`logoText ${classes.companyName}`} >{name ?? 'Selynk'}</span>
                        </div>
                    </div>
                </Bar>
                <div className='addActivityDiv' style={{backgroundColor:'#fff',marginTop:'10px'}}> 
                            
                    {/* company img */}
                    <div className={classes.imgDiv}>
                        <img src={image ?? logoImg} alt="profile" onError={(e)=>{e.target.onerror = null; e.target.src=logoImg}} className={classes.coverImg}/>
                    </div>

                    <div className='editActInfoDiv3' style={{width:'500px'}}>
                        
                        {/* city infon & btn */}
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <LocationOnOutlined style={{color:'#B329CD'}}/>
                                <span className='actloText' style={{fontFamily:"'Cairo', sans-serif",marginLeft:'20px',fontWeight:'normal'}}>{city ? `${city}, ${countryCode}` : countryCode}</span>
                            </div>
                            
                            <div className={classes.bookBtn} style={{fontFamily}} onClick={this.redirect}>Book a Reservation</div>
                        </div>

                        {/* description div */}
                        <span className='actloText' style={{marginTop:'10px',fontFamily}}>Description</span>
                        <div className={classes.descDiv}>
                            {description && description.length < textLength ?
                                <span className={classes.textSpan}>{description}</span>
                            :
                                showLess ? 
                                <>
                                <span className={classes.textSpan}>{description && description.slice(0,textLength)}</span>
                                <span className={classes.showBtn} onClick={()=> this.setShowBtn(false)}>Show more</span>
                                </>
                                :
                                <>
                                <span className={classes.textSpan}>{description}</span>
                                <span className={classes.showBtn} onClick={()=> this.setShowBtn(true)}>Show less</span>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>)
        );
    }
}

export default withRouter(withStyles(styles)(withTranslation('common')(CompanyDetail)));